import FirendBaseItem from "./friend_base_item";
import Utility from "../../../../../utility/utility";
import ModuleManager from "../../../../../framework/core/module_manager";
import PlayerIconModule from "../../playericon/playerIcon";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FriendApplyItem extends FirendBaseItem{

   
    onArgree(){

        Utility.playButtonSound()
        this.eventDispatch("request_agree_apply");
    }

    onRemove(){

        Utility.playButtonSound()
        this.eventDispatch("request_remove_apply");
    }


    onItem(){
        Utility.playButtonSound()
        ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule,{userId:this.friendId,other:true})
    }
    

  
}
